export default __webpack_public_path__ + "static/media/10.66ff34f6.svg";